import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


import { AppState, Actions, store, PanelState, minDaysLater, ZapisanyFormularz, IPageState } from '../../appredux'
import { connect, Provider } from 'react-redux';
import { Trans, WithTranslation, TransProps, withTranslation } from 'react-i18next';
import { Theme, withStyles, MuiThemeProvider } from "@material-ui/core/styles";

import CONFIG from '../../cfg/config';
import { grafikOgolny, grafik, grafikOgolnyPokoje, webRoom, bookService, dostepnoscPokoju, roomsService, Result, Dostepnosc } from '../../api'

import { addDays } from '../common/calendar/dateUtils'

import Typography from '@material-ui/core/Typography';
import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@mui/icons-material/Remove';

import theme from '../../themes/themes';
import themeBlue from '../../themes/themesBlue';
import themeGreen from '../../themes/themesGreen';
import themeBrownLight from '../../themes/themesBrownLight';
import themeBrownDark from '../../themes/themesBrownDark';
import { WithStyles } from '@material-ui/styles';
import { datediff, sendErrorLog, daysFromDate, selectTheme } from '../common/helpers';
import Details from '../Details';
import { fontSelect } from '../../fonts';
import DialogError from '../centerPanel/DialogError';
import Loader from "app/common/loader/LoaderNoWindow";
import {Room} from '../Room';
import ReactDOM from 'react-dom';
import DialogDostepnosc from 'app/common/DialogDostepnosc';
import SearchIcon from '@mui/icons-material/Search';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Fab } from '@material-ui/core';
import { GRAFIK_DNI } from 'App';
import DialogNoReservation from 'app/common/DialogNoReservation';

const KOLOR_ZAZNACZENIA_OPISU = "#e65100"

type RCalendarState = {
  dateF: Date;
  dateT: Date;
  dates: string[];
  //  rooms?: webRoom[];
  selected: boolean;
  //table : cRow[],
  //open : boolean,
  //fullScreen : boolean,
  roomTab: grafikOgolnyPokoje[][],
  selectedRoom: webRoom,
  openDetails: boolean,
  openError: boolean,
  dialogContent: any,
  dostepne_pokoje: boolean,
  room: Room,

  cell: grafikOgolnyPokoje,
  minDni: number,
}

//PM 2021-11-16
//wstrzykniecie tylko uzywanych pol z magazynu danych
interface RCalendarProps extends WithStyles<typeof styles> {
  page: IPageState,
  theme: string,
  dateFrom: string,
  dateTo: string,
  graphicHighlight: string,
  roomsOld: webRoom[],
  state: PanelState,
  zapisanyFormularz: ZapisanyFormularz,
  dateFromFormularz: string,
  expanded: boolean,
  windowWidth: number,
  roomsDetailsList: dostepnoscPokoju[],
}



class RCalendar extends React.Component<RCalendarProps & WithTranslation & TransProps, RCalendarState >  {
  textTheme = fontSelect(4, 2) as React.CSSProperties;

  primary = this.props.theme === "1" ?
    theme.palette.primary.main : this.props.theme === "2" ?
      themeBlue.palette.primary.main : this.props.theme === "3" ?
        themeBrownDark.palette.primary.main : this.props.theme === "4" ?
          themeBrownLight.palette.primary.main : themeGreen.palette.primary.main;

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  constructor(props: RCalendarProps & WithTranslation & TransProps) {
    super(props, {});
    let dateF = new Date(Date.parse(this.props.dateFrom));
    let dateT = new Date(Date.parse(this.props.dateTo));
    let week = this.getWeekDates(dateF);
    this.state = {
      dateF: dateF,
      dateT: dateT,
      dates: week,
      //      rooms: [],
      //table : [], //test_rows,
      selected: false,
      //open: true,
      //fullScreen : false,
      roomTab: [],
      selectedRoom: new webRoom(),
      openDetails: false,
      openError: false,
      dialogContent: [],
      dostepne_pokoje: false,
      room: {
        minIloscDni: '',
        id: '',
        rodzPokoi: '',
        pokoj: 0,
        cena: '',
        iloscMiejsc: '',
        galleryRodzPokoi: '',
        opis: '',
        info: '',
        ktoraCenaOpis: ''
      },

      cell: new grafikOgolnyPokoje(),
      minDni: 1
    }
  }

  closeError = () => {
    this.setState({openError: false})
  }

  selectRoom = (id: string) => {
    store.dispatch(
      Actions.pageState.selectRoom(PanelState.psDetails, id)
    )
  }

  getWeekDates = (referenceDate: Date) => {
    let dates: string[] = [];
    for (var i = 0; i < 7; i++) {
      let day = addDays(referenceDate, i)
      dates.push(day.toDateString());
    }
    return dates
  }

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  czyHighlight(cell: grafikOgolnyPokoje) {
    return this.props.graphicHighlight === cell.www_rodz_pokoi_id.toString();
  }
  //   handleClose = () => {
  //     this.setState({ open: false });
  // //      store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
  //     store.dispatch(Actions.pageState.restart());
  //   };


  // setDate = (day: any) => {
  //   //console.log(day)
  //   store.dispatch(Actions.pageState.setDateFrom(day.data));
  //   //this.handleClose()
  // }

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async componentDidMount() {
    const dateF = new Date(this.props.dateFrom);
    //const dateT = new Date(this.props.dateTo);
    //var days = Math.abs(dateF.getTime() - dateT.getTime()) / (1000 * 3600 * 24);
    if (this.props.roomsOld.length > 0) {
      await this.getRoomsData()
    }
    // if(days < 21){
    //   this.getRoomsData(new Date(dateF.setDate(dateF.getDate() + 20 )).toISOString().substring(0,10))
    // } else if(days >= 31){
    //   this.getRoomsData(new Date(dateF.setDate(dateF.getDate() + 30 )).toISOString().substring(0,10))
    // } else {
    //   this.getRoomsData(this.props.page.dateTo)
    // }

    // if(days < 7 &&  window.innerWidth < 600){  
    //   this.getRoomsData(new Date(dateF.setDate(dateF.getDate() + 6 )).toISOString().substring(0,10))
    // } else if(days < 21){
    //   this.getRoomsData(new Date(dateF.setDate(dateF.getDate() + 20 )).toISOString().substring(0,10))
    // } else if(days >= 31){
    //   this.getRoomsData(new Date(dateF.setDate(dateF.getDate() + 30 )).toISOString().substring(0,10))
    // } else {
    //   this.getRoomsData(this.props.page.dateTo)
    // }

  }

  //PM 2021-11-16
  //otwarcie formularza po powrocie z autoryzacji
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async componentDidUpdate(prevProps: RCalendarProps, prevState: RCalendarState) {
    const dateF = new Date(this.props.dateFrom);
    if (prevProps.roomsOld.length === 0 && this.props.roomsOld.length > 0 
      || this.props.dateFrom !== prevProps.dateFrom || this.props.page.grafikRefresh !== prevProps.page.grafikRefresh
      || prevProps.state === PanelState.psReservPending && this.props.state === PanelState.psBrowse) {
      await this.getRoomsData()
    } 

    if(this.props.page.podstrona !==prevProps.page.podstrona){
      await this.getRoomsData(true)
    }
    //vscTest
    //console.log(this.props.zapisanyFormularz, prevProps.zapisanyFormularz)
    if (this.props.zapisanyFormularz.pokoj !== '' && prevState.roomTab.length !== this.state.roomTab.length) {
      //vscTest
      //alert('this.props.zapisanyFormularz.pokoj !== prevProps.zapisanyFormularz.pokoj && this.props.zapisanyFormularz.pokoj !== \'\'')
      const wiersz = this.state.roomTab.find(rT => rT[0].www_rodz_pokoi_id === Number(this.props.zapisanyFormularz.pokoj))

      if (wiersz) {
        //vscTest
        //alert('if (wiersz)')
        const cell = wiersz.find(x => x.data === this.props.zapisanyFormularz.dataOd)

        if (cell)
          await this.reserve(cell)
      }
    }
  }



  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  async getRoomsData(podstronaZmiana: boolean = false) {
    this.setState({ selected: false });
    let dateF = new Date(this.props.dateFrom);
    let dateTo = new Date(dateF.setDate(dateF.getDate() + GRAFIK_DNI)).toISOString().substring(0, 10)


    try {
      let res: Result<grafikOgolnyPokoje>
      let roomsOld = this.props.roomsOld

      

      if(podstronaZmiana){ 

        if(this.props.page.podstrona){ 

          let subpage: Result<webRoom>
          if(this.props.page.serwerWersja >= 5){
            subpage = await roomsService.getRoomsSubpage2(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.page.lang,
                aPodstronaNr: this.props.page.podstrona,
                aDataOd: this.props.dateFrom,
                aDataDo: dateTo
              }
            ) 
          } else {
            subpage = await roomsService.getRoomsSubpage(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.page.lang,
                aPodstronaNr: this.props.page.podstrona
              }
            )
          }
         
          await store.dispatch(Actions.pageState.updateRoomsOld(subpage.result));
          await this.getDetailsForAllRooms(this.props.dateFrom, this.props.dateFrom)

          const [rooms, grafik] = await Promise.all(
            [subpage, 
            await grafikOgolny.getRoomsSubpage({
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")), 
              aManagerOK: 0, 
              aDataOd: this.props.dateFrom, 
              aDataDo: dateTo,
              aPodstronaNr: this.props.page.podstrona
            }, {})
            ]);

            
            roomsOld = rooms.result
            res = grafik

            
        } else {

          let rooms1: Result<webRoom>
          if(this.props.page.serwerWersja >= 5){ //nowe
            rooms1 = await roomsService.getRooms2(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.page.lang,
                aDataOd: this.props.dateFrom,
                aDataDo: dateTo
              }
            )
          } else { //stare
            rooms1 = await roomsService.getRooms(
              {
                hotelId: CONFIG.hotelID,
                aOperatorId: Number(sessionStorage.getItem("operator_id")),
                aDomena: this.props.page.lang,
              }
            )
          }

          const [rooms, grafik] = await Promise.all(
            [rooms1, 
            await grafikOgolny.getRooms({
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")), 
              aManagerOK: 0, 
              aDataOd: this.props.dateFrom, 
              aDataDo: dateTo,
            }, {})
            ]);

            await store.dispatch(Actions.pageState.updateRoomsOld(rooms.result));
            roomsOld = rooms.result
            res = grafik
         
        }

      } else {

        if(this.props.page.podstrona){
          res = await grafikOgolny.getRoomsSubpage({
            hotelId: CONFIG.hotelID,
            aOperatorId: Number(sessionStorage.getItem("operator_id")), aManagerOK: 0, aDataOd: this.props.dateFrom, aDataDo: dateTo, aPodstronaNr: this.props.page.podstrona
          }, {})
        } else {
          res = await grafikOgolny.getRooms({
            hotelId: CONFIG.hotelID,
            aOperatorId: Number(sessionStorage.getItem("operator_id")), aManagerOK: 0, aDataOd: this.props.dateFrom, aDataDo: dateTo
          }, {})
        }

      }

      


     
      let tab: grafikOgolnyPokoje[] = res.result;

      await store.dispatch(Actions.pageState.updateGrafik(tab));

      let tablica: grafikOgolnyPokoje[][] =  roomsOld.map(x => [])

      const dateF = new Date(this.props.dateFrom);
      const dateT = new Date(dateTo);
      var days = Math.abs(dateF.getTime() - dateT.getTime()) / (1000 * 3600 * 24) + 1;


      for (let i = 0; i < res.result.length / days; i++) {
        for (let y = 0; y < days; y++) {
          tablica[i].push({ ...res.result[i * days + y] })
        }
      }
      this.setState({
        roomTab: tablica,
        selected: true,
      });
    } catch (error) {
      await sendErrorLog("0", "-1", '/manager/recepcjaDajWwwGrafikOgolnyTresc0')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaDajWwwGrafikOgolnyTresc0", 2))
      console.log(error)
    }



  }

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  reserve = async (cell: grafikOgolnyPokoje) => {
    if(CONFIG.hotelRezerwuj !== "1"){

      ReactDOM.render(
        <Provider store={store}>
            <MuiThemeProvider theme={selectTheme("5")}>
                <DialogNoReservation randomNum={Math.random()}/>
            </MuiThemeProvider>
        </Provider>, document.getElementById("dialog"))

    } else {
    const t = this.props.t
    let wciecie = '  * ';
    const room = this.props.roomsOld.find((room) => room.www_rodz_pokoi_id === cell.www_rodz_pokoi_id)


    if(cell.podstrona_nr){
      await store.dispatch(Actions.pageState.setPodstrona(cell.podstrona_nr)); 
    } else if (room) {
      let dostepnoscPokoju2D = this.state.roomTab.filter((x: grafikOgolnyPokoje[]) => room.www_rodz_pokoi_id === x[0].www_rodz_pokoi_id).flat()
      let dostepnoscPokoju = dostepnoscPokoju2D.filter((x: grafikOgolnyPokoje) => cell.kolumna <= x.kolumna)
      
      let diff = datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo))
      let czyDiff = false

    
        
      
      let dniMinimum: number = room.ilosc_dni_min

      if(diff > dniMinimum) {
        dniMinimum = diff
        czyDiff = true
      }

      let dostepnaRezerwacja: boolean = true
      let dateTo: string = ""

       if(dostepnoscPokoju.length < dniMinimum){ //ostatnie dni grafika, sprawdzenie dostępności


        let res: Dostepnosc
      if(this.props.page.serwerWersja >= 5){
          res = await bookService.dajCeny(
            {
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")),
              //lang: this.props.page.lang,
              aRodzPokoiId: room.www_rodz_pokoi_id,
              aDataOd: cell.data,
              aDataDo: daysFromDate(new Date(cell.data), dniMinimum),
            }, {}
          );
      } else {
        res = await bookService.dajDostepnosc(
          {
            hotelId: CONFIG.hotelID,
            aOperatorId: Number(sessionStorage.getItem("operator_id")),
            //lang: this.props.page.lang,
            aRodzPokoiId: room.www_rodz_pokoi_id,
            aDataOd: cell.data,
            aDataDo: daysFromDate(new Date(cell.data), dniMinimum),
          }, {}
        );
        
      }


         if(!res || !res.result || res.result.length <= 0){
          dostepnaRezerwacja = false
          dateTo = daysFromDate(new Date(cell.data), dniMinimum)
         }
        
       } else { //początek grafika, sprawdzenie dostępności
        for (let i = 0; i < dniMinimum; i++) {
          if(dostepnoscPokoju[i].dostepna_ilosc_pokoi <= 0){
            dostepnaRezerwacja = false
          }  
        }
        dateTo = daysFromDate(new Date(cell.data), dniMinimum)
       }
       
      if(dostepnaRezerwacja){ //rezerwacja
        //const roznica_dni: number = datediff(new Date(this.props.dateFromFormularz), new Date(this.props.dateTo));

       // console.log(cell.data !== this.props.dateFrom)
       // console.log(roznica_dni)

        //if (cell.data !== this.props.dateFrom)
          await store.dispatch(Actions.pageState.reserve0WithDateFromFormularz(cell.www_rodz_pokoi_id.toString(), cell.data, minDaysLater(cell.data, dniMinimum)));
        //else if (roznica_dni < room.ilosc_dni_min)
        //  await store.dispatch(Actions.pageState.reserve0(cell.www_rodz_pokoi_id.toString(), minDaysLater(this.props.dateFromFormularz, room.ilosc_dni_min)));

        await store.dispatch(Actions.pageState.updateBasketOld(room));
        
       
        await store.dispatch(Actions.pageState.clearDaneNIP()); // mz 2022-06-24
        await store.dispatch(Actions.pageState.setPanelState(PanelState.psUser));
      } else { //brak miejsc  

        let dialogContent
        if(czyDiff){
          dialogContent  = [
            { message: t("Selected period of stay") + ": ", messageBoldPrimary: dniMinimum + " " + t("Days") },
            { message: "" },
            { message: t("In time") + ":" },
            { message: wciecie + t("Check-in") + ": ", messageBoldPrimary: cell.data },
            { message: wciecie + t("Check-out") + ": ", messageBoldPrimary: dateTo },
            { message: wciecie + t("No rooms") + ": ", messageBoldPrimary: room.opis },
        ];
        } else {
          dialogContent  = [
            { message: t("The minimum stay is") + ": ", messageBoldPrimary: dniMinimum + " " + t("Days") },
            { message: "" },
            { message: t("In time") + ":" },
            { message: wciecie + t("Check-in") + ": ", messageBoldPrimary: cell.data },
            { message: wciecie + t("Check-out") + ": ", messageBoldPrimary: dateTo },
            { message: wciecie + t("No rooms") + ": ", messageBoldPrimary: room.opis },
        ];
        }
        this.setState({openError: true, dialogContent: dialogContent})
      }    
    }
  }
  }

  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  openDetails = (row: grafikOgolnyPokoje[]) => {
    //console.log(row)
    const t = this.props.t

    const cell = row[0]
    const room = this.props.roomsOld.find((room => room.www_rodz_pokoi_id === cell.www_rodz_pokoi_id))
    if (room) {
      let dost = cell.dostepna_ilosc_pokoi >= 1 
      let ktoraCena = room.ktora_cena === 0
      ? t('Room-day')
      : room.ktora_cena === 1
        ? t('Person-day') : ""

        let res_dost = null;
        if(this.props.roomsDetailsList)
          res_dost = this.props.roomsDetailsList.find(element => element.pokoj === room.www_rodz_pokoi_id);

      let r = {
        cena: res_dost ? String(res_dost.cena_pokoj) : String(room.cena_pokoj),
        galleryRodzPokoi: `0-${room.www_rodz_pokoi_id}`,
        id: room.www_rodz_pokoi_id,
        iloscMiejsc: String(room.ilosc_miejsc),
        info: room.info,
        minIloscDni: String(room.ilosc_dni_min),
        opis: room.opis,
        pokoj: 0,
        rodzPokoi: room.rodz_pokoi,
        ktoraCenaOpis: ktoraCena,
      }

      this.setState({ selectedRoom: room, openDetails: true, dostepne_pokoje: dost, room: r })

    }
  }

  closeDetails = () => {
    this.setState({ openDetails: false })
  }

  setPodstrona = async (podstrona: number) => {
    await store.dispatch(Actions.pageState.setPodstrona(podstrona || 0)); 
  }

  dostepnosc = async () => {
    await store.dispatch(Actions.pageState.setSprawdzDostepnosc(false));

    // gdy rezerwacja, to nie ma okna
    if (CONFIG.rezNr === "" || CONFIG.telNr === "") {
      let dost = this.state.roomTab.flat().find((x => x.dostepna_ilosc_pokoi > 0))
      if (!dost) {
        this.openDialog()
      }
    }

  }

  openDialog = () => {
    let num: number = Math.random()

    ReactDOM.render(
      <Provider store={store}>
        <MuiThemeProvider theme={selectTheme(this.props.theme)}>
          <DialogDostepnosc randomNum={num} okCallback={this.przejdzDoWolnejDaty}
          />
        </MuiThemeProvider>
      </Provider>, document.getElementById("dialog"))
  };

przejdzDoWolnejDaty = async () => {
  await store.dispatch(Actions.pageState.setPanelState(PanelState.psReservPending));

  let dateF = this.props.dateFrom;
  let dateTo = this.daysLater(dateF, GRAFIK_DNI)

  let waronek = true
  while (waronek) {
    dateF = this.daysLater(dateF, GRAFIK_DNI)
    dateTo = this.daysLater(dateTo, GRAFIK_DNI)

    try {
      let res = await grafikOgolny.getRooms({
        hotelId: CONFIG.hotelID,
        aOperatorId: Number(sessionStorage.getItem("operator_id")),
        aManagerOK: 0,
        aDataOd: dateF,
        aDataDo: dateTo,
      }, {})

      let dost = res.result.filter((x => x.dostepna_ilosc_pokoi > 0))
      if (dost.length > 0) {
        waronek = false
        let posortowane = dost.sort((a, b) => a.kolumna - b.kolumna);
        let minDateObj = posortowane.find((x => x.dostepna_ilosc_pokoi > 0))
        if (minDateObj) {
          await store.dispatch(Actions.pageState.setDateTo(daysFromDate(new Date(minDateObj.data), 1)));
          await store.dispatch(Actions.pageState.setDateFrom(minDateObj.data));
          await this.getDetailsForAllRooms(minDateObj.data, minDateObj.data)
          await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
          await store.dispatch(Actions.pageState.setRefreshCalendar());
        }
      }       
    } catch (error) {
      waronek = false
      await store.dispatch(Actions.pageState.setPanelState(PanelState.psBrowse));
      await sendErrorLog("0", "-1", '/manager/recepcjaDajWwwGrafikOgolnyTresc0')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/manager/recepcjaDajWwwGrafikOgolnyTresc0", 2))
      console.log(error)
    }
      
  }
}

getDetailsForAllRooms = (dataOd : string, dataDo : string) => { // mz 2022-06-13
  if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3"){
    try {
      let list : dostepnoscPokoju[] = [];

      this.props.page.roomsOld.forEach(async (room1, key, arr) => {
        let item = await this.getDetails(room1.www_rodz_pokoi_id, dataOd, dataDo);
        //console.log('getDetails - item - ' + item?.cena_pokoj);

        if(item != null){
          item.pokoj = room1.www_rodz_pokoi_id;
          list.push(item);
        }

        if (Object.is(arr.length - 1, key)){
          await store.dispatch(Actions.pageState.setRoomDetailsList(list));
        }
      });

    } catch (err) {
      sendErrorLog("0", "-1", 'sprawdzenie dostępności pokoju')
      store.dispatch(Actions.pageState.addFcmLogMessage("sprawdzenie dostępności pokoju", 2))
      console.log(err);
    }
  }
}

getDetails = async (aRodzPokoi : number, dataOd : string, dataDo : string): Promise<dostepnoscPokoju | null> => { // mz 2022-06-13
  let ret = null;

  try {

    let res: Dostepnosc
    if(this.props.page.serwerWersja >= 5 && this.props.page.podstrona > 0){
      res = await bookService.dajCenyPodstrona(
        {
            hotelId: CONFIG.hotelID,
            aOperatorId: Number(sessionStorage.getItem("operator_id")),
            aRodzPokoiId: aRodzPokoi,
            aPodstronaNr: this.props.page.podstrona,
            aDataOd: dataOd, //this.props.page.dateFrom
            aDataDo: daysFromDate(new Date(dataDo), GRAFIK_DNI + 1)
            //d
        }, {}
      );
      await store.dispatch(Actions.pageState.setCeny(res.result, aRodzPokoi))
    } else if(this.props.page.serwerWersja >= 5){
      res = await bookService.dajCeny(
        {
            hotelId: CONFIG.hotelID,
            aOperatorId: Number(sessionStorage.getItem("operator_id")),
            aRodzPokoiId: aRodzPokoi,
            aDataOd: dataOd, //this.props.page.dateFrom
            aDataDo: daysFromDate(new Date(dataDo), GRAFIK_DNI + 1)
            //d
        }, {}
      );
      await store.dispatch(Actions.pageState.setCeny(res.result, aRodzPokoi))
    } else {
      res = await bookService.dajDostepnosc(
        {
            hotelId: CONFIG.hotelID,
            aOperatorId: Number(sessionStorage.getItem("operator_id")),
            aRodzPokoiId: aRodzPokoi,
            aDataOd: dataOd, //this.props.page.dateFrom
            aDataDo: dataDo, //this.props.page.dateFrom
        }, {}
      );    
    }

          
      if (Array.isArray(res.result) && res.result.length) {
          let resDost = res.result[0];

          // let aDataOd = this.props.page.dateFrom // 4 linie testowe, do zakomentowania w produkcji
          // console.log('Data: ' + aDataOd + " " + getDayOfWeekFromDate(aDataOd))
          // if(getDayOfWeekFromDate(aDataOd).includes('sobota') || getDayOfWeekFromDate(aDataOd).includes('niedziela'))
          //     resDost.cena_pokoj += 50;

          //console.log('getDetails - ' + resDost.cena_pokoj)
          ret = resDost;
      }
  } catch (err) {
      await sendErrorLog("0", "-1", 'sprawdzenie dostępności pokoju')
      await store.dispatch(Actions.pageState.addFcmLogMessage("sprawdzenie dostępności pokoju", 2))
      console.log(err);
  }

  return ret;
}

daysLater = (date: string, dni: number): string => {
  let d = new Date(date)
  return new Date(d.setDate(d.getDate() + dni)).toISOString().substring(0, 10)
}

setKolor = (cell: grafikOgolnyPokoje) => {
  let room = this.props.roomsOld.find((room) => room.www_rodz_pokoi_id === cell.www_rodz_pokoi_id)
  if(room){
    this.setState({cell: cell, minDni: room.ilosc_dni_min})
  }
}

clearKolor = () => {
  this.setState({cell: new grafikOgolnyPokoje(), minDni: 1})
}

kolumnaKolor = (day: grafikOgolnyPokoje) => {
  return this.state.cell.kolumna <= day.kolumna && this.state.cell.kolumna + this.state.minDni > day.kolumna
}

dniRezerwacji = (day: grafikOgolnyPokoje) => {
    let odKiedy = 0
    let diff = datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo))
    //let ileDni = 3
    return odKiedy <= day.kolumna && odKiedy + diff +1 > day.kolumna
  }


  //PM 2021-11-16
  //wstrzykniecie tylko uzywanych pol z magazynu danych
  render() {
    const { classes } = this.props;
    const t = this.props.t

    let primary = theme.palette.primary.main
    let error = theme.palette.error.main

    // <Typography variant="h6" component="h2" color="primary" style={{ ...this.textTheme, padding: "20px", fontSize: "14px" }}>
    //       <b><Trans>Loading...</Trans></b>
    //     </Typography>

    let allRooms = true
    this.state.roomTab.forEach(x => {
      if(x.length === 0){
        allRooms = false
      }
    })

    if (!this.state.selected || this.state.roomTab.length === 0 || this.props.roomsOld.length === 0 || !allRooms)
      return (
        <Loader/>
      )
    else {
      if(this.props.page.sprawdzDostepnosc){
        this.dostepnosc()
      }

      let headers = [
        <TableCell key={99} component="th" scope="row"
          style={{ position: "sticky", top: "0", padding: "0", background: "white", borderRight: "1px solid rgba(224, 224, 224, 1)", borderBottom: "0" }} >
          <Typography
            gutterBottom
            component="h6"
            className={`${classes.cell} ${classes.teal}`} //${classes.orange}
            style={{
              ...this.textTheme,
              minWidth: this.props.windowWidth < 600 ? '133px' : "165px",
              minHeight: this.props.windowWidth < 600 ? "42px" : "30px",
              borderBottom: "1px solid rgba(170, 170, 170, 1)",
              padding: this.props.windowWidth <= 600 ? "0px 4px 0px 6px" : "6px 10px",
            }}
          >
            <Trans>Accommodation</Trans>
          </Typography>
        </TableCell>,
      ]
      
      this.state.roomTab[0].forEach((day: grafikOgolnyPokoje, index: number) => {
        let headerText = day._data_opis.split(" ").join('<br>')
        let dzisaj = daysFromDate(new Date, 0) === day.data //&& index === 0
        let jutro = daysFromDate(new Date, 1) === day.data //&& index === 1
        headers.push(
          <TableCell
            key={`${day.wiersz} * ${day.kolumna}`}
            align="center"
            style={{
              minWidth: dzisaj ? "64px" : jutro ? "48px" : "32px", 
              maxWidth: dzisaj ? "80px" : jutro ? "60px" : "40px", 
              padding: "4px 0px 0px 0px", position: "sticky", top: "0", fontSize: "11px", lineHeight: "1rem", height: "38px",
              borderRight: this.state.roomTab[0].length === index + 1 ? "0" : "1px solid rgba(224, 224, 224, 1)", borderBottom: "0", color: `#${day.dataFontKolor}`, background: `#${day.dataTloKolor}`
            }}

          >
            <div style={{ borderBottom: "1px solid rgba(170, 170, 170, 1)", height: "inherit" }} dangerouslySetInnerHTML={{ __html: headerText }}></div>
          </TableCell>)
      }
      )

      // headers.push(
      //   <TableCell  style={{ background: "white", borderBottom: "0", padding: "0", position: "sticky", top: "0",}}>
      //     <div style={{borderBottom: "1px solid rgba(170, 170, 170, 1)", height: "42px", padding: "0px 4px"}}></div>
      //   </TableCell>
      // )  
      // if(window.innerWidth > 600)  
      //   headers.push(
      //     <TableCell  style={{padding: "8px", borderBottom: "0"}}></TableCell>
      //   )        

      let tablica: JSX.Element[][] = []
      for (let i = 0; i < this.props.roomsOld.length; i++) {
        tablica.push([])
      }


      this.state.roomTab.forEach((row: grafikOgolnyPokoje[], index) => {
        tablica[index].push(
          <TableCell key={`${row[0].wiersz} * -1`} component="th" scope="row" onClick={() => {row[0].podstrona_nr ? this.setPodstrona(row[0].podstrona_nr) : this.openDetails(row)}}
            className={classes.hover}
            style={{ background: this.state.cell.www_rodz_pokoi_id === this.props.roomsOld[index].www_rodz_pokoi_id ? "yellow" : `#${row[row.length - 1].tloKolor}`, padding: this.props.windowWidth <= 600 ? "0px 4px 0px 6px" : "2px 10px", borderRight: "1px solid rgba(224, 224, 224, 1)", borderBottom: this.state.roomTab.length === index + 1  ? "0" : "1px solid rgba(224, 224, 224, 1)", cursor: "pointer" }}>
            <Typography
              gutterBottom
              component="h6"
              className={`${classes.cell} ${classes.teal}`}
              style={{
                ...this.textTheme,
                color: this.czyHighlight(row[0]) ? KOLOR_ZAZNACZENIA_OPISU : this.textTheme.color,
                minWidth: this.props.windowWidth < 600 ? '133px' : "165px",
                minHeight: this.props.windowWidth < 600 ? "35px" : "30px"
              }}
            >
              <SearchIcon style={{ ...this.textTheme, width: "0.6em", color: `${this.textTheme.color}`, marginRight: "3px" }}></SearchIcon>
              {this.props.roomsOld[index].opis}
            </Typography>
          </TableCell>
        )
        row.forEach((day: grafikOgolnyPokoje, i: number) => {
          let cenaZero = this.props.page.ceny[day.www_rodz_pokoi_id] && this.props.page.ceny[day.www_rodz_pokoi_id][i] && this.props.page.ceny[day.www_rodz_pokoi_id][i].cena_pokoj === 0
          let tlo = this.state.cell.www_rodz_pokoi_id === day.www_rodz_pokoi_id && this.kolumnaKolor(day)
          tablica[index].push(
            <TableCell
              key={`${day.wiersz} * ${day.kolumna}`}
              align="center"
              onClick={day.dostepna_ilosc_pokoi >= 1 &&  !cenaZero ? async () => await this.reserve(day) : () => { }}
              //className={classes.hover}
              onMouseEnter={() => this.setKolor(day)}
              onMouseLeave={this.clearKolor}
              style={{
                background: tlo ? "yellow" : this.dniRezerwacji(day) ? `rgb(255, 255, 225)` : `#${day.tloKolor}`,
                //background: tlo ? "yellow" : `#${day.tloKolor}`,
                 width: `calc(70%/${GRAFIK_DNI + 1}`, padding: this.props.page.grafikMode === 1 && day.dostepna_ilosc_pokoi >= 1 ? "4px 6px 4px 6px" : "4px 6px 0px 6px", cursor: day.dostepna_ilosc_pokoi >= 1 && !cenaZero ? "pointer" : "default",
                borderRight: row.length === i + 1 ? "0" : "1px solid rgba(224, 224, 224, 1)",
                borderBottom: this.state.roomTab.length === index + 1  ? "0" : "1px solid rgba(224, 224, 224, 1)",
              }} >
               
              {day.dostepna_ilosc_pokoi < 1 || cenaZero ? 
              <RemoveIcon color="error" style={{ ...this.textTheme, width: "0.3em" }}></RemoveIcon> 
              : this.props.page.grafikMode === 1 ? 
              <span style={{ ...this.textTheme, fontSize: "11px", color: day.dostepna_ilosc_pokoi < 1 ? `${error}` : `${primary}` }}  >{ this.props.page.ceny[day.www_rodz_pokoi_id] && this.props.page.ceny[day.www_rodz_pokoi_id][i] ? this.props.page.ceny[day.www_rodz_pokoi_id][i].cena_pokoj : ""}</span>
               :
               <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em", color: `${primary}` }}></CheckIcon>}
            </TableCell>
          )
        });
        // tablica[index].push(
        //   <TableCell  style={{padding: "4px"}}></TableCell>
        // )   
        // if(window.innerWidth > 600)
        //   tablica[index].push(
        //     <TableCell  style={{padding: "8px", borderBottom: "0"}}></TableCell>
        //   )       
      });




      const rows = tablica.map((row, index) => (
        <TableRow key={this.state.roomTab[index][0].www_rodz_pokoi_id}>
          {row}
        </TableRow>
      ))

      let res_dost = null;
      if(this.props.roomsDetailsList)
        res_dost = this.props.roomsDetailsList.find(element => element.pokoj === this.state.selectedRoom.www_rodz_pokoi_id);

      return (
        <div
          id="grafik"
          className={classes.root} //380px
          style={{ maxHeight: this.props.roomsOld.length <= 7 || this.props.expanded ? "1500px" : "256px", overflowX: this.props.windowWidth < 1190 ? "auto" : "hidden" }}
        >
          <Table style={{ position: "relative", borderCollapse: "collapse", borderBottom: "1px solid rgb(224, 224, 224)" }}>
            <TableHead >
              <TableRow >
                {headers}
              </TableRow>           
            </TableHead>
            <TableBody>
              {rows}
            </TableBody>
          </Table>
          <Details
            details={{
              info: this.state.selectedRoom.info,
              opis: this.state.selectedRoom.opis,
              cena: res_dost ? String(res_dost.cena_pokoj) : this.state.selectedRoom.cena_pokoj.toString(),
              cenaZa: this.state.selectedRoom.ktora_cena === 0
                ? t('Room-day')
                : this.state.selectedRoom.ktora_cena === 1
                  ? t('Person-day') : "",
              dniMin: this.state.selectedRoom.ilosc_dni_min.toString(),
              osobMax: this.state.selectedRoom.ilosc_miejsc.toString(),
              podstrona: this.state.selectedRoom.podstrona_nr
            }}
            open={this.state.openDetails}
            close={this.closeDetails}
            pokoje_dostepne={this.state.dostepne_pokoje} 
            room={this.state.room}
            />
            <DialogError open={this.state.openError} close={this.closeError} dialogContent={this.state.dialogContent}/>
        </div>
      )
    }
  }
}

const styles = (theme: Theme) => ({
  root: {
    position: "relative" as "relative",
    overflowX: "auto" as "auto",
    maxHeight: "380px",
  },
  paper: {
    marginTop: theme.spacing(3),
    width: '100%',
    //    overflowX: 'clip',
    marginBottom: theme.spacing(2)
  },

  back: {
    color: "#ffffff",
    textShadow: "0 -1px 0 rgba(0, 0, 0, 0.25)",
    background: "linear-gradient(to bottom, #e49a4d, #c9823c)",
    border: "1px solid #c9823c",
    padding: "6px 8px 5px",
    lineHeight: "13px",
    fontSize: "11px",
    marginTop: "24px"
  },
  display: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "8px",
    height: "49.8px"
  },
  cell: {
    lineHeight: "14px",
    fontSize: "11px",
    //fontWeight: 600,
    //margin: "10px 0",
    minHeight: "35px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0px",
    fontWeight: "bold" as "bold",
  },
  hover: {
    "&:hover": {
      backgroundColor: "yellow !important"
    }
  },
  teal: {
    color: '#3a87ad',
  },
  orange: {
    color: 'rgb(230, 81, 0)',
  },
  dialog: {
    maxHeight: "100%",
    maxWidth: "none",
    padding: "8px 0px 0px 16px",
  },
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState,
  theme: state.pageState.theme,
  dateFrom: state.pageState.dateFrom,
  dateTo: state.pageState.dateTo,
  graphicHighlight: state.pageState.graphicHighlight,
  roomsOld: state.pageState.roomsOld,
  state: state.pageState.state,
  zapisanyFormularz: state.pageState.zapisanyFormularz,
  dateFromFormularz: state.pageState.dateFromFormularz,
  roomsDetailsList: state.pageState.roomDetailsList,
});

  export default withStyles(styles)(connect(mapStateToProps)(withTranslation()(RCalendar)));